export const layers = (zoom) => [
    {
        "id": "trail-highlight",
        "type": "line",
        "source": "route",
        "source-layer": "trail",
        "layout": {
            "visibility": "none",
            "line-join": "round",
            "line-cap": "round",
            "visibility": "none"
        },
        "paint": {
            "line-color": "#FFFF33",
            "line-width": 5
        }
    },
    {
        "id": "route",
        "type": "line",
        "source": "route",
        "source-layer": "trail",
        "layout": {
            "line-join": "round",
            "line-cap": "round"
        },
        "paint": {
            "line-color": "#c41919",
            "line-width": 3,
        }
    },
    {
        "id": "step-marker",
        "type": "circle",
        "source": "route",
        "source-layer": "step",
        "minzoom": 4,
        "paint": {
            "circle-color": "#FFFFFF",
            "circle-stroke-width": 3,
            "circle-stroke-color": "#B22222",
            "circle-radius": { stops: [[10, 1], [13, 3]]},
            "circle-opacity": { stops: [[10, 0], [10, 1]]},
            "circle-stroke-opacity": { stops: [[10, 0], [10, 1]]},
        }
    },
    {
        "id": "trail-start-stop-marker",
        "type": "circle",
        "source": "route",
        "source-layer": "step",
        "minzoom": 4,
        "paint": {
            "circle-color": "#FFFFFF",
            "circle-stroke-width": 3,
            "circle-stroke-color": "#B22222",
            "circle-radius": { stops: [[5, 2], [7, 5]]},
            "circle-opacity": { stops: [[5, 0], [5, 1]]},
            "circle-stroke-opacity": { stops: [[5, 0], [5, 1]]},
        }
    },

]
